<style scoped>
@import url("../assets/css/index.css");
</style>

<template>
    <div class="home-content common-home-content" v-show="show">
        <ul class="pr ice_bg space_pb clearfix" v-show="show">
            <li class="ce-index-departments fl pr"
                v-for="(learning, index) in learnings"
                :key="index"
            >
                <div class="a pr" 
                    :class="[(index+1)%4?'clumn_4':'', (index+1)%3?'clumn_3':'', learning.pinyin + '_depart']"
                    @click="linkClick(learning.pinyin, learning.label)"
                >
                    <p class="font-level4">
                        <span v-if="learning.label == '耳鼻喉科'">耳鼻喉</span>
                        <span v-else-if="learning.label == '传染病科'">传染科</span>
                        <span v-else-if="learning.label == '精神病科'">精神科</span>
                        <span v-else>{{learning.label}}</span>
                    </p>
                    <span class="free_icon_r" v-show="false" v-if="learning.free"></span>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>

export default {
  data() {
    return {
      learnings: [],
      seed: new Date().getTime(),
      show: false
    };
  },
  created() {
    var t = this.$utils.getUrlKey("t");
    if(t){
      this.seed = t;
    }
    this.loadinti();
    window.appBack = ()=> this.pageback();
  },
  methods: {
    loadinti(){
        var that = this;
        var s = this.$utils.getUrlKey("s");
        this.$api.get("/ce/", {"r": s}).then(function(res) {
            that.learnings = res.data.departments;
            that.show = true;
        });
    },
    linkClick(pinyin, label){
        this.$router.push({path:'/exam/' + label,query: {s: this.seed, pinyin: pinyin}});
    },
    pageback(){
      return null;
    }
  }
}
</script>

